import { Language } from "../libs/proto/commUnity_pb"; 

export const signup_langs: Language[] = [
  0,
  2
];
